"use client";

import { Oval, type OvalProps } from "react-loader-spinner";

type SpinnerProps = OvalProps & {
	size?: "micro" | "xs" | "sm" | "md" | "lg" | "xl" | null;
};

const getSpinnerSize = (size: SpinnerProps["size"]): number => {
	if (size === "micro") return 18;
	if (size === "sm") return 27;
	return 27;
};

const getSpinnerSizeOptions = (size: SpinnerProps["size"]): OvalProps => {
	if (!size) return {};
	return {
		height: getSpinnerSize(size),
		width: getSpinnerSize(size),
	};
};

export function Spinner({ ...props }: SpinnerProps): React.ReactElement {
	return (
		<Oval
			color={props.color}
			height={27}
			secondaryColor="#666"
			strokeWidth={6}
			width={27}
			{...props}
			{...getSpinnerSizeOptions(props.size)}
		/>
	);
}
